import { useRegisterShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { useCallback } from 'react';
/**
 * Registers a keyboard shortcut (⌘U on macOS, Ctrl+U on Windows/Linux)
 * that opens the file upload dialog via the keyboard shortcuts registry.
 *
 * Keybinding, label, and group are resolved from the shortcut manifest.
 */
export function FileUploadKeyboardShortcut({ gateUploadFile, onOpenFilePicker, }) {
    const handler = useCallback((event) => {
        // Prevent default file input behavior — handled programmatically
        event.preventDefault();
        const gateError = gateUploadFile('local');
        if (!gateError) {
            onOpenFilePicker();
            return;
        }
    }, [gateUploadFile, onOpenFilePicker]);
    useRegisterShortcut({ id: 'file-upload', handler });
    return null;
}
//# sourceMappingURL=FileUploadKeyboardShortcut.js.map